import React, { useState } from "react";
import { auth } from "../firebase";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

const provider = new GoogleAuthProvider();

// Bewusst kein Selbstregistrierungs-Formular mehr: Konten werden ausschließlich vom Admin
// über die Firebase Console angelegt (Einladungsprinzip), um Zugriff auf Anmeldedaten und
// persönliche Module kontrollieren zu können.
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fehler, setFehler] = useState("");
  const [hinweis, setHinweis] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFehler(""); setHinweis("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setFehler(err.message);
    }
  };

  const handleGoogle = async () => {
    setFehler(""); setHinweis("");
    try {
      await signInWithPopup(auth, provider);
    } catch (err) {
      setFehler(err.message);
    }
  };

  const handleForgot = async () => {
    setFehler(""); setHinweis("");
    if (!email) { setFehler("Bitte zuerst die E-Mail-Adresse eingeben."); return; }
    try {
      await sendPasswordResetEmail(auth, email);
      setHinweis("E-Mail zum Zurücksetzen wurde verschickt.");
    } catch (err) {
      setFehler(err.message);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Anmelden</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            style={styles.input}
            type="email"
            placeholder="E-Mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {fehler && <p style={styles.fehler}>{fehler}</p>}
          {hinweis && <p style={styles.hinweis}>{hinweis}</p>}
          <button style={styles.button} type="submit">
            Anmelden
          </button>
        </form>
        <button style={styles.googleButton} onClick={handleGoogle}>
          Mit Google anmelden
        </button>
        <p style={styles.umschalten} onClick={handleForgot}>
          Passwort vergessen?
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f2f5",
  },
  card: {
    backgroundColor: "white",
    padding: "2rem",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    width: "320px",
  },
  form: { display: "flex", flexDirection: "column", gap: "0.8rem" },
  input: {
    padding: "0.6rem",
    fontSize: "1rem",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  button: {
    padding: "0.7rem",
    backgroundColor: "#1a73e8",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "1rem",
  },
  googleButton: {
    marginTop: "0.8rem",
    width: "100%",
    padding: "0.7rem",
    backgroundColor: "white",
    border: "1px solid #ccc",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "1rem",
  },
  fehler: { color: "red", fontSize: "0.85rem" },
  hinweis: { color: "#2f7d54", fontSize: "0.85rem" },
  umschalten: {
    marginTop: "1rem",
    textAlign: "center",
    color: "#1a73e8",
    cursor: "pointer",
    fontSize: "0.9rem",
  },
};
